/* eslint-disable camelcase */
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

const AppSettings = async () => {
  const { langFile } = await DataHandler.getLanguage();
  const appId = await DataHandler.matchAppId();
  const locale = `${langFile}_${langFile}`;
  const appInfo = await APIHandler.getAppInfo(appId, locale);

  if (appInfo) {
    const {
      landingVideo,
      profile_image_header,
      logo,
      logo_white,
      logo_wide_color,
      logo_wide_white,
      splashScreen,
      primary_color,
      secondary_color,
      landing_quote,
      programBenefits,
      facebook,
      flickr,
      instagram,
      twitter,
      youtube,
      pinterest,
      googlePlus,
      linkedin,
      appName,
      login_image,
      tikTok,
      general_background_image,
      background_images,
      video_email_copy,
      video_email_subject,
      image_email_copy,
      image_email_subject,
      shareTitle,
      shareCopy,
    } = appInfo.app[0];

    const socials = {
      tiktok: tikTok !== '' ? tikTok : null,
      facebook: facebook !== '' ? facebook : null,
      flickr: flickr !== '' ? flickr : null,
      instagram: instagram !== '' ? instagram : null,
      twitter: twitter !== '' ? twitter : null,
      youtube: youtube !== '' ? youtube : null,
      pinterest: pinterest !== '' ? pinterest : null,
      googlePlus: googlePlus !== '' ? googlePlus : null,
      linkedin: linkedin !== '' ? linkedin : null,
    };

    const appInfoObject = {
      generalBackgroundImage: general_background_image
        ? general_background_image.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
        : null,
      backgroundImages: background_images?.map((Image) => ({
        ...Image,
        image: Image.image.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com'),
      })),
      backgroundImage: splashScreen
        ? splashScreen.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
        : null,
      backgroundVideo: landingVideo
        ? landingVideo.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
        : null,
      loginImage: login_image ? login_image.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com') : null,
      logo: logo ? logo.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com') : null,
      logoWhite: logo_white ? logo_white.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com') : null,
      logoWide: logo_wide_color
        ? logo_wide_color.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
        : null,
      logoWideWhite: logo_wide_white
        ? logo_wide_white.replace('s3.amazonaws.com/developertool', 'front.travpromobile.com')
        : null,
      primaryColor: primary_color !== '' ? primary_color : null,
      secondaryColor: secondary_color !== '' ? secondary_color : null,
      profileImageHeader: profile_image_header !== '' ? profile_image_header : null,
      landingQuote: landing_quote !== '' ? landing_quote : null,
      appName: appName !== '' ? appName : null,
      programBenefits,
      socials,
      video_email_copy,
      video_email_subject,
      image_email_copy,
      image_email_subject,
      shareTitle,
      shareCopy,
    };

    StorageHandler.save(storageKeys.appInfo, appInfoObject);

    return true;
  }
  return false;
};

export default AppSettings;
